export default __webpack_public_path__ + "static/media/animation.3a72db59.gif";